// extracted by mini-css-extract-plugin
export default {"note":"AppointmentSummaryNote_note__dfRQ+","date-txt":"AppointmentSummaryNote_date-txt__bkgeL"};